import { toError } from 'helpers/toError';

/**
 * Extract a renderable error string from a backend response body
 * (`err.response?.data`) or an already-extracted message.
 *
 * Backend APIs return either `{error: "message"}`, `{message: "..."}`, or a
 * plain string. Storing the raw object in Redux state crashes React (error
 * #31) when a component renders it as a child, so slices funnel error data
 * through here before assigning it to `state.error`.
 *
 * Thin wrapper over {@link toError}, which owns the `.error` / `.message` /
 * string extraction. `fallback` is returned when the body carries no
 * extractable message (empty / unrecognised body, or a network error with no
 * response). Pass the axios `error.message` as the fallback to surface the
 * HTTP status line in that case.
 */
export function extractErrorMessage(responseData: unknown, fallback: string): string {
  return toError(responseData, fallback).message;
}
